import { combineReducers } from 'redux';
import { default as ChangePassReducer, default as ChangeUserPassword } from './ChangePass.reducer';
import GetDashboardData from './Dashboard.reducer';
import FUserChangePassword from './FUserChagePass.reducer';
import GetLicenceKey from './GenerateLicenceKey.reducer';
import GetAllFacilityDetails from './GetFacility.reducer';
import GetReaderDataReducer from './GetManchesterReaderData';
import GetWanderReaderData from './GetWanderReaderData.reducer';
import GetFacilityUserList from './GetfacilityUser.reducer';
import Theme from './Theme';
import UpdateLicenceStatus from './Updatestatus.reducer';
import addContractedHours4GrpReducer from './addContractedHours4Grp.reducer';
import AddFacility from './addFacility.reducer';
import FacilityUser from './addFacilityUser.reducer';
import addGroupUserReducer from './addGroupUser.reducer';
import AddLicence from './addLicence.reducer';
import addMachineDetailsReducer from './addMachineDetails.reducer';
import AddReaderData from './addReaderDetail.reducer';
import AddUser from './addUser.reducer';
import clothesNotWashedReducer from './clothesNotWashed.reducer';
import DashboardGraphDetailsReducer from './dashboardGraphDetails.reducer';
import DeleteFacilityUser from './deletFacilityUser.reducer';
import DeleteGroup from './deletGroup.reducer';
import DeleteReaderDetial from './deletReaderDetail.reducer';
import DeleteWanderDetail from './deletWanderDetail.reducer';
import deleteContractedHours4GrpReducer from './deleteContractedHours4Grp.reducer';
import deleteGroupUserReducer from './deleteGroupUser.reducer';
import deleteMachineDetailsReducer from './deleteMachineDetails.reducer';
import deleteUserReducer from './deleteUser.reducer';
import editContractedHours4GrpReducer from './editContractedHours4Grp.reducer';
import { default as DeleteFacility, default as EditFacility } from './editFacility.reducer';
import EditFacilityUser from './editFacilityUser.reducer';
import EditGroup from './editGroup.reducer';
import editGroupUserReducer from './editGroupUser.reducer';
import editMachineDetailsReducer from './editMachineDetails.reducer';
import EditModuleDetail from './editModuleDetail.reducer';
import EditUserProfile from './editProfile.reducer';
import EditReaderDetail from './editReaderDetail.reducer';
import EditWanderModuleDetail from './editWanderModuleDetail.reducer';
import { default as AddGroup, default as FacilityList } from './facilityList.reducer';
import ForgotPassword from './forgotPassword.reducer';
import GarmentWashReoprt from './garmentwash.reducer';
import getAverageDailyClothsWashReducer from './getAverageDailyClothsWash.reducer';
import getClothItemsReducer from './getClothItems.reducer';
import getContractedHoursReducer from './getContractedHours.reducer';
import getContractedHours4GrpReducer from './getContractedHours4Grp.reducer';
import getDashboardByCategoryReducer from './getDashboardByCategory.reducer';
import getDeliveredClothsReducer from './getDeliveredCloths.reducer';
import getDeliveredClothsForResidentReducer from './getDeliveredClothsForResident.reducer';
import GetFacilityDetailsById from './getFacilityDetailsById.reducer';
import GetFacilityGroupWise from './getFacilityGroupwise.reducer';
import FacilityUserById from './getFacilityUserDetailsById.reducer';
import getGroupDashboardLinenReducer from './getGroupDashboardLinen.reducer';
import GetGroupDetailsById from './getGroupDetailsById.reducer';
import getGroupFacilitiesReducer from './getGroupFacilities.reducer';
import GetGroupList from './getGroupList.reducer';
import getGroupUsersReducer from './getGroupUsers.reducer';
import getInventoryDataReducer from './getInventoryData.reducer';
import getItemsWashPerHourReducer from './getItemsWashPerHour.reducer';
import getLostItemsReducer from './getLostItems.reducer';
import getMachinesCapacityReducer from './getMachineCapacity.reducer';
import getMachineDetailsReducer from './getMachineDetails.reducer';
import getMonthlyReportData from './getMonthlyReport.reducer';
import GetReaderDetailById from './getReaderDetailsById.reducer';
import getResidenceReducer from './getResidence.reducer';
import getResidentClothListingReducer from './getResidentClothListing.reducer';
import GetScanningModuleData from './getScanningModuleList.reducer';
import getSummaryReportReducer from './getSummaryReport.reducer';
import GetWanderDetailByID from './getWanderDetailsById.reducer';
import getWeeklyReportReducer from './getWeeklyReport.reducer';
import GetStateListReducer from './getstateList.reducer';
import groupAverageWashPerResidentReducer from './groupAverageWashPerResident.reducer';
import groupDashboardProductivityReducer from './groupDashboardProductivity.reducer';
import groupItemsWashedPerHourReducer from './groupItemsWashedPerHour.reducer';
import GroupList from './groupList.reducer';
import groupTrendsReducer from './groupTrends.reducer';
import itemsWashedPerHourPerKgReducer from './itemsWashedPerHourKg.reducer';
import LedMappingReport from './ledmapping.reducer';
import GetLicence from './licence.reducer';
import LicenceList from './licenceList.reducer';
import linenNotWashedReducer from './linenNotWashed.reducer';
import Login from './login.reducer';
import lowestHighestWashCountReducer from './lowestHighestWashCount.reducer';
import newResidentReducer from './newResident.reducer';
import residentCountForGroupReducer from './residentCountForGroup.reducer';
import residentWashCountReducer from './residentWashCount.reducer';
import residentWiseDeliveredCountReducer from './residentWiseDeliveredCount.reducer';
import ResidentListingReport from './residentlisting.reducer';
import selectedRowDataReducer from './selectedRowData.reducer';
import SetNewPassword from './setNewPassword.reducer';
import summaryBookletReducer from './summaryBooklet.reducer';
import summaryBookletBodyReducer from './summaryBookletBody.reducer';
import topMaxWashCountReducer from './topMaxWashCount.reducer';
import trackedLostItemsReducer from './trackedLostItems.reducer';
import userListReducer from './userList.reducer';
import UserProfile from './userProfile.reducer';
import washCountComparisonReducer from './washCountComparison.reducer';
import weeklyLaundryReportReducer from './weeklyLaundryReport.reducer';

const reducers = combineReducers({
	theme: Theme,
	userLogin: Login,
	userProfile: UserProfile,
	setNewPassword: SetNewPassword,
	forgotPassword: ForgotPassword,
	userLicenceDetails: GetLicence,
	residentListingReport: ResidentListingReport,
	ledMappingReport: LedMappingReport,
	garmentWashReoprt: GarmentWashReoprt,
	editUserProfile: EditUserProfile,
	addFacility: AddFacility,
	getGroupList: GetGroupList,
	addLicence: AddLicence,
	getFacilityGroupWise: GetFacilityGroupWise,
	licenceList: LicenceList,
	groupList: GroupList,
	facilityList: FacilityList,
	addGroup: AddGroup,
	addUser: AddUser,
	getLicenceKey: GetLicenceKey,
	updateLicenceStatus: UpdateLicenceStatus,
	getAllFacilityDetails: GetAllFacilityDetails,
	getDashboardData: GetDashboardData,
	editGroup: EditGroup,
	editFacility: EditFacility,
	deleteGroup: DeleteGroup,
	deleteFacility: DeleteFacility,
	getFacilityDetailsById: GetFacilityDetailsById,
	getGroupDetailsById: GetGroupDetailsById,
	changeUserPassword: ChangeUserPassword,
	getStateList: GetStateListReducer,
	facilityUser: FacilityUser,
	getFacilityUserList: GetFacilityUserList,
	deleteFacilityUser: DeleteFacilityUser,
	facilityUserById: FacilityUserById,
	editFacilityUser: EditFacilityUser,
	fUserChangePassword: FUserChangePassword,
	getReaderData: GetReaderDataReducer,
	addReaderData: AddReaderData,
	deleteReaderDetial: DeleteReaderDetial,
	getReaderDetailById: GetReaderDetailById,
	editReaderDetail: EditReaderDetail,
	editModuleDetail: EditModuleDetail,
	getWanderReaderData: GetWanderReaderData,
	getScanningModuleData: GetScanningModuleData,
	deleteWanderDetail: DeleteWanderDetail,
	getWanderDetailByID: GetWanderDetailByID,
	editWanderModuleDetail: EditWanderModuleDetail,
	dashboardGraphDetails: DashboardGraphDetailsReducer,
	topMaxWashCountReducer: topMaxWashCountReducer,
	lowestHighestWashCount: lowestHighestWashCountReducer,
	getMonthlyReportData: getMonthlyReportData,
	getResidenceList: getResidenceReducer,
	summaryReport: getSummaryReportReducer,
	residentClothListing: getResidentClothListingReducer,
	lostItemsFound: getLostItemsReducer,
	selectedRowData: selectedRowDataReducer,
	summaryBooklet: summaryBookletReducer,
	summaryBookletBody: summaryBookletBodyReducer,
	deliveredClothsDetails: getDeliveredClothsReducer,
	weeklyReport: getWeeklyReportReducer,
	newResident: newResidentReducer,
	clothesNotWashed: clothesNotWashedReducer,
	deliveredClothes: getDeliveredClothsReducer,
	washCountComparisonReducer: washCountComparisonReducer,
	averageDailyCloths: getAverageDailyClothsWashReducer,
	userList: userListReducer,
	deleteUser: deleteUserReducer,
	changePassword: ChangePassReducer,
	getDeliveredClothsForResident: getDeliveredClothsForResidentReducer,
	residentWiseDeliveredCount: residentWiseDeliveredCountReducer,
	inventoryData: getInventoryDataReducer,
	groupTrends: groupTrendsReducer,
	residentWashCount: residentWashCountReducer,
	residentCountForGroup: residentCountForGroupReducer,
	groupDashboardLinenInventory: getGroupDashboardLinenReducer,
	groupDashboardProductivityReducer: groupDashboardProductivityReducer,
	trackedLostItemsCounts: trackedLostItemsReducer,
	machineCapacity: getMachinesCapacityReducer,
	contractedHours: getContractedHoursReducer,
	clothItems: getClothItemsReducer,
	itemsWashedPerHour: getItemsWashPerHourReducer,
	itemsWashedPerHourPerKg: itemsWashedPerHourPerKgReducer,
	groupItemWashedPerHour: groupItemsWashedPerHourReducer,
	linenNotWashed: linenNotWashedReducer,
	groupAverageWashPerResidentReducer: groupAverageWashPerResidentReducer,
	contractedHours4Grp: getContractedHours4GrpReducer,
	addContractedHours4Grp: addContractedHours4GrpReducer,
	editContractedHours4Grp: editContractedHours4GrpReducer,
	deleteContractedHours4Grp: deleteContractedHours4GrpReducer,
	getMachineDetails: getMachineDetailsReducer,
	addMachineDetails: addMachineDetailsReducer,
	editMachineDetails: editMachineDetailsReducer,
	deleteMachineDetail: deleteMachineDetailsReducer,
	addGroupUser: addGroupUserReducer,
	editGroupUser: editGroupUserReducer,
	getGroupUsers: getGroupUsersReducer,
	deleteGroupUser: deleteGroupUserReducer,
	getGroupFacilities: getGroupFacilitiesReducer,
	dashboardByCategory: getDashboardByCategoryReducer,
	weeklyLaundryReport: weeklyLaundryReportReducer,
});

export default reducers;
